import React from 'react';

export default function UserTerms() {
  return (
    <div style={{ 
      display: 'flex', 
      background: '#020617', 
      minHeight: '100vh', 
      color: 'white',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '40px'
    }}>
      <div style={{ maxWidth: '800px', lineHeight: '1.6' }}>
        <h1>Terms of Service</h1>
        
        <p style={{ marginTop: '20px' }}>
          <strong>Last updated:</strong> April 2025
        </p>

        <h3 style={{ marginTop: '25px', color: '#38bdf8' }}>Acceptance of Terms</h3>
        <p>
          By accessing or using WWMMCGC, you agree to be bound by these Terms of Service.
          If you disagree with any part, you may not access the service.
        </p>

        <h3 style={{ marginTop: '25px', color: '#38bdf8' }}>User Conduct</h3>
        <p>
          Users agree to respect other players, avoid abusive behavior,
          and not misuse the platform. Any violation may result in account suspension.
        </p>

        <h3 style={{ marginTop: '25px', color: '#38bdf8' }}>Account Security</h3>
        <p>
          You are responsible for maintaining the security of your account.
          Notify us immediately of any unauthorized access.
        </p>

        <h3 style={{ marginTop: '25px', color: '#38bdf8' }}>Contact</h3>
        <p>
          For support: <strong>support@wwmmcgc.com</strong>
        </p>
      </div>
    </div>
  );
}